import { NgModule } from '@angular/core';
import {
	Activity,
	AlertCircle,
	AppWindowMac,
	Archive,
	ArrowDown,
	ArrowDownRight,
	ArrowDownUp,
	ArrowLeft,
	ArrowLeftRight,
	ArrowRight,
	ArrowUp,
	ArrowUpRight,
	BadgeDollarSign,
	BadgeEuro,
	Banknote,
	BarChart2,
	BarChart3,
	Bell,
	BellOff,
	BellRing,
	Bitcoin,
	Bolt,
	BookOpen,
	Bot,
	Boxes,
	Brain,
	BrickWall,
	Briefcase,
	BriefcaseBusiness,
	Building,
	Building2,
	Calculator,
	Calendar,
	Calendar1,
	CalendarClock,
	CalendarDays,
	CalendarOff,
	CalendarPlus,
	CalendarRange,
	Camera,
	Caravan,
	ChartSpline,
	Check,
	CheckCircle,
	CheckSquare,
	ChevronDown,
	ChevronFirst,
	ChevronLast,
	ChevronLeft,
	ChevronRight,
	ChevronUp,
	CircleAlert,
	CircleArrowRight,
	CircleCheck,
	CircleDashed,
	CircleDollarSign,
	CircleX,
	ClipboardCheck,
	ClipboardList,
	Clock,
	Clock3,
	ClockArrowUp,
	CloudUpload,
	Code,
	Coins,
	Construction,
	ContactRound,
	Cookie,
	Copy,
	CreditCard,
	Cross,
	DollarSign,
	DoorOpen,
	Download,
	Drill,
	Droplets,
	Edit,
	Ellipsis,
	EllipsisVertical,
	ExternalLink,
	Eye,
	EyeOff,
	File,
	FileArchive,
	FileCheck,
	FileClock,
	FileDown,
	FileInput,
	FileJson,
	FilePlus,
	FileSignature,
	FileSpreadsheet,
	FileText,
	FileUp,
	FileX,
	Filter,
	Flame,
	FlaskConical,
	FolderOpen,
	Gem,
	Ghost,
	GraduationCap,
	GripHorizontal,
	GripVertical,
	Handshake,
	Hash,
	Heart,
	HelpCircle,
	Home,
	House,
	IdCard,
	IdCardLanyard,
	Image,
	Inbox,
	Info,
	Landmark,
	Layers,
	LayoutDashboard,
	LayoutGrid,
	LifeBuoy,
	LineChart,
	Link,
	Link2,
	List,
	ListChecks,
	ListCollapse,
	ListFilter,
	Loader,
	LoaderCircle,
	Lock,
	LockKeyhole,
	LogOut,
	LucideAngularModule,
	Mail,
	MapPin,
	Menu,
	MessageCircle,
	MessageSquare,
	MessageSquarePlus,
	MessageSquareText,
	Mic,
	Minus,
	Monitor,
	Moon,
	MoreVertical,
	MoveLeft,
	MoveRight,
	Package,
	Palette,
	PanelLeftClose,
	PanelLeftOpen,
	Paperclip,
	Pencil,
	PencilRuler,
	PenTool,
	Percent,
	Phone,
	PhoneCall,
	PlayCircle,
	Plug,
	Plus,
	Printer,
	Receipt,
	ReceiptText,
	RefreshCw,
	RotateCcw,
	Save,
	Scale,
	ScrollText,
	Search,
	Send,
	Settings,
	Settings2,
	Shield,
	ShieldAlert,
	ShieldCheck,
	ShoppingCart,
	Siren,
	SlidersHorizontal,
	SquareDashedMousePointer,
	SquareMousePointer,
	SquarePlus,
	Squircle,
	Star,
	StarOff,
	Stethoscope,
	Sun,
	Syringe,
	Tag,
	Ticket,
	Tickets,
	Timer,
	TimerReset,
	ToolCase,
	Trash,
	Trash2,
	TrendingUp,
	TriangleAlert,
	Undo2,
	Unlock,
	Upload,
	User,
	UserCheck,
	UserCog,
	UserPlus,
	UserRound,
	UserRoundCog,
	Users,
	UsersRound,
	UserX,
	Wallet,
	Waves,
	Webcam,
	X,
	XCircle,
	Zap,
} from 'lucide-angular';

@NgModule({
	imports: [
		LucideAngularModule.pick({
			Activity,
			AlertCircle,
			AppWindowMac,
			ArrowDown,
			ArrowDownUp,
			ArrowLeft,
			ArrowLeftRight,
			ArrowRight,
			ArrowUp,
			ArrowUpRight,
			ArrowDownRight,
			Archive,
			BadgeDollarSign,
			BadgeEuro,
			Banknote,
			BarChart2,
			BarChart3,
			Bell,
			BellOff,
			BellRing,
			Bitcoin,
			Bolt,
			BookOpen,
			Bot,
			Boxes,
			Brain,
			BrickWall,
			Briefcase,
			BriefcaseBusiness,
			Building,
			Building2,
			Calculator,
			Calendar,
			CalendarRange,
			Calendar1,
			CalendarClock,
			CalendarDays,
			ChartSpline,
			CalendarOff,
			CalendarPlus,
			Camera,
			Caravan,
			Check,
			CheckCircle,
			CheckSquare,
			ChevronDown,
			ChevronFirst,
			ChevronLast,
			ChevronLeft,
			ChevronRight,
			ChevronUp,
			CircleAlert,
			CircleArrowRight,
			CircleCheck,
			CircleDashed,
			CircleDollarSign,
			CircleX,
			ClipboardCheck,
			ClipboardList,
			Clock,
			Clock3,
			ClockArrowUp,
			CloudUpload,
			Code,
			Coins,
			Construction,
			ContactRound,
			Cookie,
			CreditCard,
			Copy,
			Cross,
			DollarSign,
			DoorOpen,
			Download,
			Droplets,
			Drill,
			Edit,
			Ellipsis,
			EllipsisVertical,
			ExternalLink,
			Eye,
			EyeOff,
			File,
			FileArchive,
			FileCheck,
			FilePlus,
			FileClock,
			FileUp,
			FileDown,
			FileInput,
			FileJson,
			FileSignature,
			FileSpreadsheet,
			FileText,
			FileX,
			Filter,
			Flame,
			FlaskConical,
			FolderOpen,
			Gem,
			Ghost,
			GraduationCap,
			GripHorizontal,
			GripVertical,
			Handshake,
			Hash,
			Heart,
			HelpCircle,
			Home,
			House,
			IdCard,
			IdCardLanyard,
			Image,
			Inbox,
			Info,
			Landmark,
			Layers,
			LayoutDashboard,
			LayoutGrid,
			LifeBuoy,
			LineChart,
			Link,
			Link2,
			List,
			ListChecks,
			ListCollapse,
			ListFilter,
			Loader,
			LoaderCircle,
			Lock,
			LockKeyhole,
			LogOut,
			Mail,
			MapPin,
			Menu,
			MessageCircle,
			MessageSquare,
			MessageSquarePlus,
			MessageSquareText,
			Mic,
			Minus,
			Monitor,
			Moon,
			MoreVertical,
			MoveLeft,
			MoveRight,
			Package,
			Palette,
			PanelLeftClose,
			PanelLeftOpen,
			Paperclip,
			Pencil,
			PencilRuler,
			PenTool,
			Percent,
			Phone,
			PhoneCall,
			PlayCircle,
			Plug,
			Plus,
			Printer,
			Receipt,
			ReceiptText,
			RefreshCw,
			RotateCcw,
			Save,
			Scale,
			ScrollText,
			Search,
			Send,
			Settings,
			Settings2,
			Shield,
			ShieldAlert,
			ShieldCheck,
			ShoppingCart,
			Siren,
			SlidersHorizontal,
			StarOff,
			SquareDashedMousePointer,
			SquareMousePointer,
			SquarePlus,
			Squircle,
			Star,
			Stethoscope,
			Sun,
			Syringe,
			Tag,
			Ticket,
			Tickets,
			Timer,
			TimerReset,
			ToolCase,
			Trash,
			Trash2,
			TrendingUp,
			TriangleAlert,
			Undo2,
			Unlock,
			Upload,
			User,
			UserCheck,
			UserCog,
			UserPlus,
			UserRound,
			UserRoundCog,
			Users,
			UsersRound,
			UserX,
			Wallet,
			Waves,
			Webcam,
			X,
			XCircle,
			Zap,
		}),
	],
	exports: [LucideAngularModule],
})
export class LucideModule {}
